// Components Module - Collection of small CSS-only components
import './components.scss';

// CSS-only module collection - no JavaScript functionality needed
const BceComponents = {
    // This module is CSS-only, styles are automatically applied when imported
    // Contains small utility components and styling helpers
};

export default BceComponents;